<template>
  <div v-if="!isEmpty(chatList)" class="session">
    <div class="session-title light-color-3">{{ title }}</div>
    <div class="session-list">
      <div :class="['session-item',(sItem.conversationId&&sItem.conversationId===conversationId)?'active':'']"
           v-for="(sItem,sIndex) in chatList"
           :key="sIndex"
           @click="emitSelectSession(sItem,sIndex)">
        <div class="session-item-title white">{{sItem.title}}</div>
        <div class="session-item-info light-color-3">
          <div class="session-item-text">{{ sItem.messagecount || 0 }} messages</div>
          <div class="session-item-text">{{sItem.updatedAt}}</div>
        </div>
        <!-- 删除会话-->
        <i class="el-icon-close light-color-3" @click.stop="deleteSession(sItem,sIndex)"></i>
        <!-- 置顶-->
        <slot name="onTopping" :data="sItem" :sIndex="sIndex"></slot>
        <!-- 取消置顶-->
        <slot name="cancelTopping" :data="sItem" :sIndex="sIndex"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import {
  isEmpty
} from '@/util/util'
export default {
  name: "recentChat",
  props:{
    chatList:{
      type:Array,
      default:()=>{
        return []
      }
    },
    title:String
  },
  data(){
    return{

    }
  },
  computed:{
    // currentSessionIndex:{
    //   get(){
    //     return this.$store.state.chat.currentSessionIndex
    //   },
    //   set(val){
    //     this.$store.commit('chat/SET_CURRENT_SESSION_INDEX',val);
    //   }
    // },
    conversationId:{
      get(){
        return this.$store.state.chat.conversationId
      },
      set(val){
        this.$store.commit('chat/SELECT_SESSION',val)
      }
    }
  },
  methods:{
    isEmpty,
    deleteSession(sessionItem,sessionIndex){
      //this.currentSessionIndex = sessionIndex;
      this.$emit('list-delete-session',sessionItem.conversationId);
    },
    emitSelectSession(sessionItem,sessionIndex){
      //this.currentSessionIndex = sessionIndex;
      this.conversationId = sessionItem.conversationId;
      this.$emit('list-select-session', sessionItem.conversationId);
    }

  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/shareAI.scss";
</style>